export default __webpack_public_path__ + "static/media/108.7309dee3.jpg";